import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// icons
import Bitstamp from './Tables/Icons/Bitstamp (light).png'
import Binance from "./Tables/Icons/Binance.png"
import GridContainer from "components/Grid/GridContainer";

export default function SimpleSlider() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay:true
  };
  return (
    <Slider {...settings}>

      <div>
        <GridContainer style={{paddingTop:"10px",}}>
            <p style={{marginLeft:"20px", color:"#000"}}>LongSingleBot | BinanceFutures |</p>
            <p style={{marginLeft:"20px", marginTop:"5px"}}> <img width="40" height="40"  src={Binance} alt="fireSpot"/> </p>
            <p style={{color:"#000"}}>DOGE/USDT |</p>
            <p style={{marginLeft:"29px"}}> Profit:</p>
            <p style={{color:"green"}}> 0.21% ($0.69)</p>
        </GridContainer>
      </div>

      <div>
        <GridContainer style={{paddingTop:"10px"}}>
                <p style={{marginLeft:"20px", color:"#000"}}>LongSingleBot | BinanceFutures |</p>
                <p style={{marginLeft:"20px", marginTop:"5px"}}> <img width="40" height="40"  src={Bitstamp} alt="fireSpot"/> </p>
                <p style={{color:"#000"}}>DOGE/USDT |</p>
                <p style={{marginLeft:"29px"}}> Profit:</p>
                <p style={{color:"green"}}> 0.21% ($0.69)</p>
        </GridContainer>
      </div>

      <div>
        <GridContainer style={{paddingTop:"10px"}}>
                <p style={{marginLeft:"20px", color:"#000"}}>LongSingleBot | BinanceFutures |</p>
                <p style={{marginLeft:"20px", marginTop:"5px"}}> <img width="40" height="40"  src={Binance} alt="fireSpot"/> </p>
                <p style={{color:"#000"}}>DOGE/USDT |</p>
                <p style={{marginLeft:"29px"}}> Profit:</p>
                <p style={{color:"green"}}> 0.21% ($0.69)</p>
        </GridContainer>
      </div>

      <div>
        <GridContainer style={{paddingTop:"10px"}}>
                <p style={{marginLeft:"20px", color:"#000"}}>LongSingleBot | BinanceFutures |</p>
                <p style={{marginLeft:"20px", marginTop:"5px"}}> <img width="40" height="40"  src={Bitstamp} alt="fireSpot"/> </p>
                <p style={{color:"#000"}}>DOGE/USDT |</p>
                <p style={{marginLeft:"29px"}}> Profit:</p>
                <p style={{color:"green"}}> 0.21% ($0.69)</p>
        </GridContainer>
      </div>

      <div>
        <GridContainer style={{paddingTop:"10px"}}>
                <p style={{marginLeft:"20px", color:"#000"}}>LongSingleBot | BinanceFutures |</p>
                <p style={{marginLeft:"20px", marginTop:"5px"}}> <img width="40" height="40"  src={Binance} alt="fireSpot"/> </p>
                <p style={{color:"#000"}}>DOGE/USDT |</p>
                <p style={{marginLeft:"29px"}}> Profit:</p>
                <p style={{color:"green"}}> 0.21% ($0.69)</p>
        </GridContainer>
      </div>

      <div>
        <GridContainer style={{paddingTop:"10px"}}>
                <p style={{marginLeft:"20px", color:"#000"}}>LongSingleBot | BinanceFutures |</p>
                <p style={{marginLeft:"20px", marginTop:"5px"}}> <img width="40" height="40"  src={Bitstamp} alt="fireSpot"/> </p>
                <p style={{color:"#000"}}>DOGE/USDT |</p>
                <p style={{marginLeft:"29px"}}> Profit:</p>
                <p style={{color:"green"}}> 0.21% ($0.69)</p>
        </GridContainer>
      </div>

    </Slider>
  );
}